import { Button } from 'reactstrap'

export default function FormSubmitButton({ label = 'Generate Report' }) {
  console.log('FormSubmitButton rendered')

  return (
    <div style={{ textAlign: 'center', padding: '10px' }}>
      <Button color="primary" data-cy="submit-button">{label}</Button>
    </div>
  )
}
